import type { ActionState } from '../lib/types'
import { ACTION_REASON_LABEL, ACTION_STATUS_CLASSES, ACTION_STATUS_LABEL, formatDateBR } from '../lib/format'

// O estado da ação é ÚNICO: um status e um comentário, iguais para todo mundo.
// Estes componentes só exibem — sempre com a marca de quem mexeu por último,
// para ficar claro de quem veio o registro.

/** Etiqueta do status da ação (com a data do "rever" e quem registrou). */
export function ActionStateBadge({
  state,
  showAuthor = true,
}: {
  state: ActionState
  showAuthor?: boolean
}) {
  if (state.status === 'pending') return null
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-semibold ${
        ACTION_STATUS_CLASSES[state.status]
      }`}
    >
      {ACTION_STATUS_LABEL[state.status]}
      {state.status === 'review' && state.reviewAt ? ` ${formatDateBR(state.reviewAt)}` : ''}
      {state.executedAt ? ` em ${formatDateBR(state.executedAt)} (histórico da conta)` : ''}
      {state.reason && ACTION_REASON_LABEL[state.reason] ? ` · ${ACTION_REASON_LABEL[state.reason]}` : ''}
      {showAuthor && state.by ? ` · ${state.by}` : ''}
    </span>
  )
}

/** Comentário da ação, com quem escreveu por último e quando. */
export function ActionComment({
  state,
  className = '',
}: {
  state: ActionState
  className?: string
}) {
  const note = state.note?.trim()
  if (!note) return null
  return (
    <p
      className={`whitespace-pre-wrap rounded-md bg-slate-50 px-2 py-1 text-xs text-slate-600 ${className}`}
    >
      {state.by && (
        <span className="text-slate-400">
          <span className="font-semibold text-slate-500">{state.by}</span>
          {state.at ? ` · ${formatDateBR(state.at)}` : ''}
          <br />
        </span>
      )}
      {note}
    </p>
  )
}
